import { gql } from 'graphql.macro';

export const UpdateCategory = gql`
    mutation UpdateNearMissCategory($request: UpdateNearMissCategoryRequestModelInput){
      updateNearMissCategory(request: $request)
    }
`;